/**
 * Bildregistry der vier Handelsformen aus Kapitel 1 (B2C, B2B, C2C, C2B).
 *
 * Je Karte eine kleine Szene im selben 3D-Trickfilmstil wie die
 * Kapitelillustrationen: Wer verkauft hier an wen. Die Dateien liegen als AVIF
 * (klein) und WebP (Fallback) in src/assets/images/konzept/ und sind 720px
 * breit — die Karte ist auf einem großen Bildschirm rund 500px breit, das
 * reicht auch für hochauflösende Bildschirme.
 *
 * Statische Importe wie in `illustrationen.js`: Nur so nimmt der Webpack-Build
 * von CRA die Dateien mit und versieht sie mit Hash-Namen.
 */

import b2cAvif from '../../../../assets/images/konzept/handelsform-b2c.avif'
import b2cWebp from '../../../../assets/images/konzept/handelsform-b2c.webp'
import b2bAvif from '../../../../assets/images/konzept/handelsform-b2b.avif'
import b2bWebp from '../../../../assets/images/konzept/handelsform-b2b.webp'
import c2cAvif from '../../../../assets/images/konzept/handelsform-c2c.avif'
import c2cWebp from '../../../../assets/images/konzept/handelsform-c2c.webp'
import c2bAvif from '../../../../assets/images/konzept/handelsform-c2b.avif'
import c2bWebp from '../../../../assets/images/konzept/handelsform-c2b.webp'

export const HANDELSFORMEN = {
	b2c: { avif: b2cAvif, webp: b2cWebp },
	b2b: { avif: b2bAvif, webp: b2bWebp },
	c2c: { avif: c2cAvif, webp: c2cWebp },
	c2b: { avif: c2bAvif, webp: c2bWebp }
}
